<!-- 
	充值方式
	lovi 2020-07-27
 -->
<template>
  <div class="global-dl">
    <dl>
      <dt>{{ $t("wallet.rechargeType") }}：</dt>
      <dd>
        <p v-if="showDiscount && discountsList.length">
          <span class="discounts text-orange" @click="discountFlag = true">
            {{ $t("common.rechargeDiscount") }}
          </span>
        </p>
        <div class="pay-list">
          <div
            class="pay-item"
            :class="{ active: curPayIndex == index }"
            v-for="(item, index) in payList"
            :key="index"
            @click="changePay(item, index)"
          >
            <img :src="httpUrl + item.icon" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </dd>
    </dl>
    <!-- 充值优惠 -->
    <discount :discountFlag.sync="discountFlag" :list="discountsList" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Discount from "./discount";
export default {
  props: {
    type: {
      // 处理不同充值下显示不同支付方式
      type: Number,
      default: 0
    },
    showDiscount: {
      // 显示充值优惠
      type: Boolean,
      default: function() {
        return false;
      }
    },
    discountType: {
      // 特殊充值 1批量话费充值
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {
    Discount
  },
  data() {
    return {
      payList: [], //支付列表
      curPayIndex: 0,
      curPay: [], //当前支付数据
      discountFlag: false, // 充值优惠
      discountsList: []
    };
  },
  created() {
    if (this.showDiscount) {
      this.rechargeDiscount();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    changePay(data, index) {
      //修改充值方式
      this.curPayIndex = index;
      this.curPay = data;
      this.$emit("getCurPay", this.curPay);
      console.log("vm.curPay", this.curPay);
    },
    getPayType() {
      let vm = this;
      let params = {};
      vm.$post("/app/user/payType", params, { loading: true }).then(res => {
        console.log("payType", res);
        vm.payList = [];
        for (let key of res) {
          if (vm.type == 1) {
            // 余额充值
            if (key.type != 3) {
              if (key.type == vm.userInfo.pay_type) {
                vm.payList.unshift(key);
              } else {
                vm.payList.push(key);
              }
            }
          } else if (vm.type == 2) {
            // 只有余额
            if (key.type == 3) {
              vm.payList.push(key);
            }
          } else {
            // 其他充值去掉线下银行卡线下现金
            if (key.type != 7 && key.type != 8) {
              if (key.type == vm.userInfo.pay_type) {
                vm.payList.unshift(key);
              } else {
                vm.payList.push(key);
              }
            }
          }
        }
        // 默认数据
        vm.curPay = vm.payList[0];
        vm.$emit("getCurPay", vm.curPay);
        console.log("vm.payList", vm.payList);
        console.log("vm.curPay", vm.curPay);
      });
    },
    rechargeDiscount() {
      //自动充值列表
      let vm = this;
      let params = {};
      params.type = vm.discountType;
      vm.$post("/app/user/rechargeDiscount", params, { loading: true }).then(
        res => {
          console.log("rechargeDiscount", res);
          vm.discountsList = res;
        }
      );
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.username) {
          this.getPayType();
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.discounts {
  cursor: pointer;
  margin-bottom: 5px;
}
.pay-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: -10px;
  .pay-item {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 15px;
    margin-top: 10px;
    min-width: 160px;
    height: 40px;
    padding: 5px 10px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    transition: all 0.5s;
    &:hover {
      border-color: #2042ab;
    }
    &.active {
      position: relative;
      border-color: #2042ab;
      &:after {
        content: "";
        position: absolute;
        right: 0;
        bottom: 0;
        width: 25px;
        height: 20px;
        background: url("~@/assets/images/public/checked.png") no-repeat;
      }
    }
    img {
      margin-right: 8px;
      width: 30px;
      height: 30px;
    }
  }
}
</style>
